import React from "react"

import PropTypes from "prop-types"
import {Icon} from "semantic-ui-react"

import {useIsResponsive} from "../../hooks/useIsResponsive"
import {getDataTestId} from "../../utils/stringUtil"

import "./headerLink.scss"

const HeaderLink = ({
    ariaLabel = undefined,
    icon = undefined,
    label,
    textColor,
    withArrowIcon = false,
    ...props
}) => {
    const isResponsive = useIsResponsive()

    return (
        <button
            aria-label={ariaLabel || label}
            className="header-link-container"
            data-testid={label ? getDataTestId(label, "lien") : "lienHeader"}
            style={{color: textColor}}
            tabIndex={0}
            type="button"
            {...props}
        >
            {icon && <Icon aria-hidden="true" className={icon} />}
            {label && !(icon && isResponsive) && <span className="header-link-container-label">{label}</span>}
            {withArrowIcon && (
                <span>
                    <Icon aria-hidden="true" className="fa-solid fa-caret-down caret-icon" />
                </span>
            )}
        </button>
    )
}

HeaderLink.propTypes = {
    ariaLabel: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    textColor: PropTypes.string.isRequired,
    withArrowIcon: PropTypes.bool,
}

export default HeaderLink
